import packages from '../../js/package';
// import original from '../../js/original';
import '../css/style.scss';

// npmでインストールしたパッケージの読み込み
packages();

// オリジナルパーツ読み込み
// original();


// 新規のコードはこのカッコの中に記載してください。

// タブレット用 viewport切り替え
let ua = navigator.userAgent.toLowerCase();
let isMobile = /iphone/.test(ua) || /android(.+)?mobile/.test(ua);

if (isMobile) {
  $('head').prepend('<meta name="viewport" content="width=device-width,initial-scale=1">');
} else {
  $('head').prepend('<meta name="viewport" content="width=1280">');
}


window.onload = function(){
    jQuery(function(jQuery) {
        var state = false;
        var pos;
        
        // ハンバーガーメニュー
        jQuery('.navToggle').click(function() {
            jQuery(this).toggleClass('active');
    
            if (state == false) {
                    pos = jQuery(window).scrollTop();
                    jQuery('body').addClass('active').css({'top': -pos});
                    jQuery('#gnav').addClass('active');
                    jQuery('.main-header').addClass('active');
                    state = true;
                } else {
                    jQuery('body').removeClass('active').css({'top': 0});
                    jQuery('#gnav').removeClass('active');
                    jQuery('.main-header').removeClass('active');
                    window.scrollTo(0, pos);
                    state = false;
                }
        });
        
        // 園児募集とお問い合わせボタン（スクロール＆出現タイミング）
        var topBtn = jQuery('.contact-area');
        topBtn.hide();
        //スクロールが100に達したらボタン表示
        jQuery(window).scroll(function () {
            if (jQuery(this).scrollTop() > 100) {
                topBtn.fadeIn();
            } else {
                topBtn.fadeOut();
            }
        });

        //ページ内スムーススクロール
        jQuery('a[href^="#"]').click(function() {
            var speed = 400;
            var href= jQuery(this).attr("href");
            var target = jQuery(href == "#" || href == "" ? 'html' : href);
            var position = target.offset().top;
            jQuery('body,html').animate({scrollTop:position}, speed, 'swing');
            return false;
        });

        // よくあるご質問アコーディオン
        jQuery('.faq-area dl dt').on('click', function(){
            jQuery(this).toggleClass('open');
            jQuery(this).next('.faq-area dl dd').slideToggle();
        });

        // MV（スライダー）
        jQuery('.mv-slide-container').slick({
            infinite: true,
            speed: 3000,
            slidesToShow: 1,
            arrows: false,
            fade: true,
            autoplay: true,
            autoplaySpeed: 2000,
            dots: false,
      
            responsive: [
                {
                  breakpoint: 390,
                  settings: {
                  slidesToShow: 1,
                  },
                },
              ],
        });

        // Map（スライダー）
        jQuery('.map-slide-container').slick({
            autoplay: true,
            autoplaySpeed: 0,
            speed: 8000,
            cssEase: 'linear',
            arrows:false,
            swipe: false,
            pauseOnFocus: false,
            pauseOnHover: false,
            variableWidth: true,
        });

        // MV（スライダー）
        jQuery('.about .description-area.type01 .main-description .img-box').slick({
          infinite: true,
          speed: 3000,
          slidesToShow: 1,
          arrows: false,
          fade: true,
          autoplay: true,
          autoplaySpeed: 2000,
          dots: false,
    
          responsive: [
              {
                breakpoint: 390,
                settings: {
                slidesToShow: 1,
                },
              },
            ],
        });

        // 高さを揃える
        jQuery('.lineup-area .lineup-product .product-item a').matchHeight();

    });

};